
import { mapState } from "vuex";

import { colors } from "~/colors.config";

export default {
  data: () => ({ hasScrollbar: false }),

  computed: {
    ...mapState("productsSearch", ["currentPageResults"]),
    ...mapState("app", ["topBannerHeight"]),
    keySuffix() {
      return this.$route.query.query ?? this.$route.params.handle;
    },

    scrollbarStyle() {
      return {
        "--dropdown-max-height": `calc(100vh - ${
          this.topBannerHeight + 100
        }px)`,
        "scrollbar-color": `${colors.gray[400]} transparent`,
      };
    },
  },

  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.$store.dispatch("app/setRefinementListVisiblity", isVisible);
      }
    },
  },
};
